function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var SEARCH_INTERACTIONS = {
  BEGIN: 'SEARCH_INTERACTIONS.BEGIN',
  FAILURE: 'SEARCH_INTERACTIONS.FAILURE',
  SUCCESS: 'SEARCH_INTERACTIONS.SUCCESS'
};
var SEARCH_INTERACTION_TYPES = [SEARCH_INTERACTIONS.BEGIN, SEARCH_INTERACTIONS.SUCCESS, SEARCH_INTERACTIONS.FAILURE];
export var RETRIEVE_INTERACTION = {
  BEGIN: 'RETRIEVE_INTERACTION.BEGIN',
  FAILURE: 'RETRIEVE_INTERACTION.FAILURE',
  SUCCESS: 'RETRIEVE_INTERACTION.SUCCESS'
};
var RETRIEVE_INTERACTION_TYPES = [RETRIEVE_INTERACTION.BEGIN, RETRIEVE_INTERACTION.SUCCESS, RETRIEVE_INTERACTION.FAILURE];
export var SET_CATEGORY_TYPE = 'SET_CATEGORY_TYPE';
export var SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export var SET_INTERACTION_TYPE = 'SET_INTERACTION_TYPE';
export var SET_SHOW_CHANGED_TYPE = 'SET_INTERACTION_SHOW_CHANGED';
export var SET_INTERACTIONS_SORT_CRITERIA = 'SET_INTERACTIONS_SORT_CRITERIA';
var fetchInteractionsPromise = function fetchInteractionsPromise(dispatch, data) {
  return ThunkHelper(dispatch, SEARCH_INTERACTION_TYPES, {
    method: 'post',
    url: 'Configuration/SearchInteractions',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var fetchInteractions = function fetchInteractions(data) {
  return function (dispatch) {
    return fetchInteractionsPromise(dispatch, data);
  };
};
var retrieveInteractionPromise = function retrieveInteractionPromise(dispatch, data) {
  return ThunkHelper(dispatch, RETRIEVE_INTERACTION_TYPES, {
    method: 'post',
    url: 'Configuration/RetrieveInteraction',
    data: {
      Identifier: data.interactionId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var retrieveInteraction = function retrieveInteraction(data) {
  return function (dispatch) {
    return retrieveInteractionPromise(dispatch, data);
  };
};
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page
  };
};
export var setSortCriteria = function setSortCriteria(sortCriteria) {
  return {
    type: SET_INTERACTIONS_SORT_CRITERIA,
    payload: sortCriteria
  };
};
export var setCategoryType = function setCategoryType(categoryType) {
  return {
    type: SET_CATEGORY_TYPE,
    payload: categoryType
  };
};
export var setInteractionType = function setInteractionType(interactionType) {
  return {
    type: SET_INTERACTION_TYPE,
    payload: interactionType
  };
};
export var setShowChangedProperties = function setShowChangedProperties(showChanged) {
  return {
    type: SET_SHOW_CHANGED_TYPE,
    payload: showChanged
  };
};
export var EMPTY_INTERACTIONS_LIST = 'EMPTY_INTERACTIONS_LIST';
export var emptyInteractionsList = function emptyInteractionsList() {
  return {
    type: EMPTY_INTERACTIONS_LIST
  };
};
export var REMOVE_INTERACTIONS_FILTER = 'REMOVE_INTERACTIONS_FILTER';
export var removeInteractionsFilter = function removeInteractionsFilter() {
  return {
    type: REMOVE_INTERACTIONS_FILTER
  };
};
export var SET_INTERACTION_PAGE_SIZE_PREFERENCE = 'SET_INTERACTION_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_INTERACTION_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};